var _defs, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a{fill:none;opacity:0.3;}.b{fill:#41528b;}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 11,
    height: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M617.349,387.5l-4.5-6.75-4.5,6.75Z",
    transform: "translate(-607.349 -376.755)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUp);
export default __webpack_public_path__ + "static/media/ic_up.3397f190f4da331a3cbaf6bf5ef030f9.svg";
export { ForwardRef as ReactComponent };